import {appContainer} from "../contexts/app";
import Resource from "./resource";
import {fromImmutable, toImmutable, setInState, setListInState, deleteInState} from "./hooks";

export default app => {
  const service = app.service("api/training-tutorials");

  const TrainingRecord = Resource(
    service,
    {
      link: "",
      description: "",
      zendeskLink: ""
    },
    {}
  );

  appContainer.TrainingRecord = TrainingRecord;
  app.set("TrainingRecord", TrainingRecord);

  service.hooks({
    before: {
      all: [],
      find: [],
      get: [],
      create: [fromImmutable],
      update: [fromImmutable],
      patch: [fromImmutable],
      remove: []
    },

    after: {
      all: [toImmutable(TrainingRecord)],
      find: [setListInState("trainingTutorials")],
      get: [setInState("trainingTutorials")],
      create: [setInState("trainingTutorials")],
      update: [setInState("trainingTutorials")],
      patch: [setInState("trainingTutorials")],
      remove: [deleteInState("trainingTutorials")]
    },

    error: {
      all: [],
      find: [],
      get: [],
      create: [],
      update: [],
      patch: [],
      remove: []
    }
  });
};



// WEBPACK FOOTER //
// ./src/feathers/training-tutorials.js